<template>
  <transition name="fade">
    <div
    v-if="show"
    class="spinner-container">
      <b-spinner
      style="width: 3rem; height: 3rem;"
      label="Spinning"></b-spinner>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.spinner-container {
  position: fixed;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255,0.8);
}
.spinner-border {
  border-color: $red;
  border-right-color: transparent;
}
</style>
